'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDescription$0024 from "./app.data.data_point_types$package$-Description$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$() {
  this.aIm = null;
  this.aIx = null;
  this.aIr = null;
  this.aIs = false;
  this.aIv = null;
  this.aIw = false;
  this.aIn = null;
  this.aIo = false;
  this.aIt = null;
  this.aIu = false;
  this.aIp = null;
  this.aIq = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ = this;
  this.aIm = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDescription$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$();
  this.aIx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dDescription$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$.prototype = $p;
$p.eR = (function() {
  return this.aIm;
});
$p.eO = (function() {
  return this.aIx;
});
$p.b9 = (function() {
  if ((!this.aIs)) {
    this.aIr = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aIs = true;
  }
  return this.aIr;
});
$p.b3 = (function() {
  if ((!this.aIw)) {
    this.aIv = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aIw = true;
  }
  return this.aIv;
});
$p.aG = (function() {
  if ((!this.aIo)) {
    this.aIn = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aIo = true;
  }
  return this.aIn;
});
$p.az = (function() {
  if ((!this.aIu)) {
    this.aIt = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aIu = true;
  }
  return this.aIt;
});
$p.brW = (function() {
  if ((!this.aIq)) {
    this.aIp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Description";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aIq = true;
  }
  return this.aIp;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$, "app.data.data_point_types$package$DescriptionForm$", ({
  FD: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$DescriptionForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Description-Form$.js.map
